module.exports = __webpack_public_path__ + "img/logoMonOrientestBlanc.4b69a148.svg";